module.exports = __webpack_public_path__ + "img/Benefits.105b62c5.svg";